import { atom } from "recoil"

export const newMyOffersState = atom({
  key: "atoms/matching/create/newMyOffersState",
  default: false,
})
